import { render, staticRenderFns } from "./add_visits_info.vue?vue&type=template&id=d37b0970&scoped=true&"
import script from "./add_visits_info.vue?vue&type=script&lang=js&"
export * from "./add_visits_info.vue?vue&type=script&lang=js&"
import style0 from "./add_visits_info.vue?vue&type=style&index=0&id=d37b0970&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d37b0970",
  null
  
)

export default component.exports